module.exports = __webpack_public_path__ + "media/images/resource-types/pdf-0a409da925d50636ae3c652de3fa3e90.svg";